/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import { ToolbarComponentCommonProps } from '..';

interface DelegationViewToggleProps extends ToolbarComponentCommonProps {
  handleCheckbox: (status: boolean) => void;
  delegationView: boolean;
}

export const DelegationViewToggle = (props: DelegationViewToggleProps) => {
  const { handleCheckbox, delegationView } = props;
  const toggleChecked = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleCheckbox(e.target.checked);
  }

  return (
    <FormGroup check className='ml-2'>
      <Input id='delegation-view-toggle' type='checkbox' checked={delegationView} onChange={toggleChecked} />
      <Label check className='text-muted' for='delegation-view-toggle'>
        Delegation view
      </Label>
    </FormGroup>
  );
}
